<template>
  <el-dialog title="加班记录" :visible.sync="dialogVisible" v-loading="loading" :before-close="handleClose">
    <div class="content">
      <div class="item">
        <div class="label">项目名称：</div>
        <div class="value">{{ info.projectName }}</div>
      </div>
      <div class="item">
        <div class="label">加班日期：</div>
        <div class="value">{{ info.overtimeDate }}</div>
      </div>
      <div class="item" v-if="info?.workers?.length">
        <div class="label">工人信息：</div>
        <div class="value">{{ info.workersString }}</div>
      </div>
      <div class="item" v-else>
        <div class="label">班组名称：</div>
        <div class="value">{{ info.teamName }}</div>
      </div>
      <div class="item">
        <div class="label">加班人数：</div>
        <div class="value">{{ info.overtimeNum }}</div>
      </div>
      <div class="item">
        <div class="label">加班时长：</div>
        <div class="value">{{ info.overtimeHours }}</div>
      </div>
      <div class="item">
        <div class="label">加班单价：</div>
        <div class="value">{{ info.laborPrice }}</div>
      </div>
      <div class="item">
        <div class="label">费用总额：</div>
        <div class="value">{{ info.laborAmount }}</div>
      </div>
      <div class="item">
        <div class="label">加班说明：</div>
        <div class="value">{{ info.remark }}</div>
      </div>
      <div class="imgList">
        <span>加班图片：</span>
        <div v-if="info?.fileList?.length" class="ListBox">
          <div class="imgItem" v-for="(item, key) in info.fileList" :key="key">
            <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
              fit="fill">
            </el-image>
            <!-- <el-image
                  v-if="imgList.find((items) => items === item.fileName.split('.')[1])"
                  :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="info.repairList | imgListFormat"
                  fit="fill">
                </el-image>
                <video v-if="videoList.find((items) => items === item.fileName.split('.')[1])" controls="controls" :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]" fit="fill">
                </video> -->
          </div>
        </div>
        <div v-else description="暂无图片"></div>
      </div>
      <div class="item">
        <div class="label">填报人：</div>
        <div class="value">{{ info.createUserName }}</div>
      </div>
      <div class="item">
        <div class="label">填报时间：</div>
        <div class="value">{{ info.createTime }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WorkerListDetails',
  props: {
    detailsId: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      info: {
        projectName: '',
        overtimeDate: '',
        workers: [],
        workersString: '',
        teamName: '',
        overtimeNum: '',
        signProjectName: '',
        remark: '',
        fileList: [],
        updateUserId: '',
        updateTime: ''
      }
    }
  },
  filters: {
    imgListFormat (list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },

  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhOvertimeRecordDetailByOvertimeId, { overtimeId: this.detailsId }).then(res => {
        // res.workersString
        let workersString = ''
        if (res.workers) {
          res.workers.forEach((item, index) => {
            if (index === res.workers.length - 1) {
              workersString = workersString + item.workerName + ''
            } else {
              workersString = workersString + item.workerName + '、'
            }
          })
        }
        res.workersString = workersString
        this.info = res
      }).finally(() => {
        // this.loading = false
      })
    },

    handleClose () {
      this.$emit('update:detailsShow', false)
      this.$emit('update:detailsId', '')
      this.info = {
        projectName: '',
        overtimeDate: '',
        workers: [],
        workersString: '',
        teamName: '',
        overtimeNum: '',
        signProjectName: '',
        remark: '',
        fileList: [],
        updateUserId: '',
        updateTime: ''
      }
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  width: 480px;
  height: 529px;
}

::v-deep .el-dialog__body {
  padding: 20px 30px;
  overflow-y: auto;
  height: 470px;
}

.content {
  font-size: 12px;
  height: auto;
  font-size: 14px;

  .item {
    line-height: 25px;
    margin-bottom: 17px;
    display: flex;

    .label {
      width: 75px;
      text-align: right;
    }

    .value {
      flex: 1;
      padding-right: 10px;
    }
  }

  .imgList {
    display: flex;
    margin-bottom: 20px;

    span {
      display: inline-block;
      width: 75px;
      text-align: right;
    }

    .ListBox {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .imgItem {
        width: 102px;
        height: 102px;
        margin: 0 10px 10px 0;

        .el-image,
        img,
        video {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
